import { type FunctionComponent } from 'react';
import QuickShipIcon from '../svgs/quick-ship.svg';
import { quickShip } from './quick-ship.css';

export type QuickShipProps = {
	message: string;
	cutoffMessage?: string | null;
	shippingCutoffExceedsThreshold?: boolean;
	cutoffMessageClasses?: string;
	dataTestId?: string;
	showZipCodeChanger?: boolean;
	messageClasses?: string;
};

export const QuickShip: FunctionComponent<QuickShipProps> = ({
	message,
	cutoffMessage,
	shippingCutoffExceedsThreshold,
	cutoffMessageClasses = '',
	dataTestId = '',
	messageClasses = 'font-medium'
}) => (
	<div data-automation="quickship-message" data-testid={dataTestId}>
		<QuickShipIcon className={`f2 mr1 relative theme-accent ${quickShip} `} data-testid="QuickShipIcon" />
		<span className={messageClasses}>{message}</span>
		{shippingCutoffExceedsThreshold ? (
			<span className={`${cutoffMessageClasses} pl1`}>
				if ordered <strong>Today</strong>
			</span>
		) : cutoffMessage ? (
			<span className={`${cutoffMessageClasses} pl1`}>
				if ordered in the next <span className="font-medium">{cutoffMessage}</span>
			</span>
		) : null}
	</div>
);
